import { useParams } from "wouter";

/**
 * Custom hook that returns the folderId from URL params.
 * If the folderId equals "root", returns undefined.
 * @returns The folderId from URL params, or undefined if it's "root" or not present
 */
export const useFolderId = (): string | null => {
  const { folderId } = useParams<{ folderId?: string }>();
  return (folderId === "root" ? null : folderId) || null;
};
